export default "__VITE_ASSET__Byjwy4jX__"